import { forwardRef, useEffect } from "react";
import { TextField, Grid, InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  setInitialPosInfoDialog,
  resetForm,
  Wallet,
} from "../../../app/slices/walletSlice";
import { NumericFormat } from "react-number-format";
import { HiOutlineWallet, HiOutlineBanknotes } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../components/FormDialog";

const InitialPosInfoForm = () => {
  const _InitialPosInfo = useSelector((state) => state.wallet.initialPosInfo);
  const _SearchBody = useSelector((state) => state.user.searchBody);

  const { control, handleSubmit } = useForm({
    defaultValues: _InitialPosInfo.form,
  });


  const onSubmit = (data) => {
    dispatch(Wallet.initialBalanceAndDebt(_InitialPosInfo.pos_id, data, _SearchBody));
  };

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setInitialPosInfoDialog(null));
  };

  const NumericFormatCustom = forwardRef(function NumericFormatCustom(
    props,
    ref,
  ) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  });

  return (
    <FormDialog
      open={_InitialPosInfo.dialog}
      onClose={handleDialog}
      icon={<HiOutlineWallet />}
      title="تحديث حساب نقطة البيع"
      subtitle="أدخل الرصيد والديون لنقطة البيع ثم احفظ"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="المبالغ">
        <Grid item xs={12} sm={6}>
          <Controller
            name="balance"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الرصيد"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: <InputAdornment position="start">IQD</InputAdornment>,
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="debt"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الديون"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: <InputAdornment position="start">IQD</InputAdornment>,
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default InitialPosInfoForm;
